export const validNumber = (number: string): boolean => {
  if (number.slice(0, 1) === "+" && number.length > 7 && number.length !== 0) {
    return true;
  }
  return false;
};
